import { FileText, House, PuzzlePiece, SignOut, User } from 'phosphor-react';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Sidebar, Menu } from 'semantic-ui-react';
import packageInfo from '../../../package.json';
import logoEthosx from '../../assets/images/logo.png';
import { styleSheet } from '../../assets/styles/global';
import EditUserProfile from '../EditUserProfile';
import {
  MainLogo,
  VersionContainer,
  VersionText,
  CustomMenuItem,
  CloseButton,
  SideMenuContainer,
  SidebarHeader
} from './styles';
// ... imports

interface Props {
  currentMenu: string;
  visible: boolean;
  onClose: () => void;
}

const SideMenu: React.FC<Props> = ({ currentMenu, visible, onClose }) => {
  const [editUserProfileModal, setEditUserProfileModal] = useState(false)
  const history = useHistory()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')
    window.location.reload();
  }

  return (
    <Sidebar
      as={Menu}
      animation='overlay'
      direction='right'
      vertical
      visible={visible}
      onHide={onClose}
      style={{
        backgroundColor: 'rgb(250, 250, 250)',
        zIndex: 9999,
        width: 'auto', // Dynamic width
        maxWidth: '90vw',
        borderLeft: '1px solid #eee'
      }}
    >
      <SideMenuContainer>
        <SidebarHeader>
          <MainLogo src={logoEthosx} />
          <CloseButton size={15} weight="light" onClick={onClose} />
        </SidebarHeader>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
          <CustomMenuItem
            active={!editUserProfileModal && currentMenu === 'calendario'}
            onClick={() => history.push('/schedule')}
          >
            <House size={24} weight={(!editUserProfileModal && currentMenu === 'calendario') ? "fill" : "light"} />
            Calendário
          </CustomMenuItem>

          <CustomMenuItem
            active={!editUserProfileModal && currentMenu === 'skills'}
            onClick={() => history.push('/skills')}
          >
            <PuzzlePiece size={24} weight={(!editUserProfileModal && currentMenu === 'skills') ? "fill" : "light"} />
            Skills
          </CustomMenuItem>

          <CustomMenuItem
            active={!editUserProfileModal && currentMenu === 'report'}
            onClick={() => history.push('/report')}
          >
            <FileText size={24} weight={(!editUserProfileModal && currentMenu === 'report') ? "fill" : "light"} />
            Relatório
          </CustomMenuItem>

          <CustomMenuItem
            active={editUserProfileModal}
            onClick={() => setEditUserProfileModal(true)}
          >
            <User size={24} weight={editUserProfileModal ? "fill" : "light"} />
            Perfil
          </CustomMenuItem>

          <CustomMenuItem
            active={currentMenu === 'logout'}
            onClick={handleLogout}
          >
            <SignOut size={24} weight="light" />
            Sair
          </CustomMenuItem>
        </div>

        <VersionContainer style={{ marginTop: 'auto', padding: '20px' }}>
          <VersionText style={{ color: '#aaa' }}>v{packageInfo.version}</VersionText>
        </VersionContainer>

      </SideMenuContainer>

      {
        editUserProfileModal && (
          <EditUserProfile visible={editUserProfileModal} closeModal={() => setEditUserProfileModal(false)} />
        )
      }
    </Sidebar>
  );
}

export default SideMenu;